const Form005TC = {
    stepName: {
        basicInformation: "基本資料",
        activitiesInformation: "計劃的各項活動資料",
        effectiveness: "計劃成效與意見",
        incomeExpenditure: "活動收支表",
        cost: "計劃行政費及統籌開支表",
        confirmation: "確認",
    },
    notes: {
        tips1: "1. 電子表格所載的資料均以教育局網頁上之表格為準",
        tipsUrl:
            "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. {{schoolyear}} 學年校本課後學習及支援計劃 區本計劃–進度報告(截至 {{upToDateTc}} 日為止)(須於 {{deadLineTc}}或之前透過網上電子表格(",
        tips2b: ")填妥及遞交此報告至教育局學生特別支援組。此外，機構亦可以郵寄或傳真遞交已填妥及簽署的報告至本局。)",
        tipsUrl2: "https://eformss.edb.gov.hk/eformss/Login",
        remarks: {
            tips1: "合資格學生：領取綜援、學生資助計劃全額津貼或使用酌情權的清貧學生（只適用於有協作學校之活動，並由校方提供）",
            tips2: "非合資格學生：自費參加活動的學生，參加學生<u>必須繳付全費</u>，全費是指每名參加學生（包括合資格及非合資格學生）在活動的<span><b>實際</b>總開支</span>所佔成本（例如：活動實際總開支為1,000元，有6名合資格學生及4名非合資格學生參加，每一名學生的成本便是100元；每一名非合資格學生因此需繳付100元）",
            tips3: "活動是否如期舉辦：註明活動為<b>(a) 已完成；(b) 正在進行；(c) 未開展 或 (d) 取消</b>",
            tips4: "活動資助額：指從核准計劃分配給這項活動的款項。（<u>只資助合資格學生</u>，非合資格學生須全費繳付活動實際總開支。）",
            tips5: "其他收入：例如<u>非合資格學生</u>所繳交的參加費用、捐款及贊助等。如在現階段尚未知悉有關數額，請填「待定」",
            tips6: "開支：舉辦活動的實際開支（包括機構補貼活動的開支），如在現階段尚未知悉有關數額，請填「待定」",
            tips7: "各類別的學生\n- NCS（非華語學生）\n- SEN（有特殊學習需要的學生）\n- NAC（新來港學童）",
            tips8: "若活動包括開放予區內合資格學生，機構應<u><b>優先取錄</b></u>合資格的Od類學生\n- Od（來自(I)項以外的官立、津貼、按位津貼學校、直接資助計劃學校及私立學校的學生）\n- Cs（來自(I)項所列協作學校的學生）",
        },
    },
    label: {
        basicInformation: "基本資料",
        organisationName: "機構名稱",
        projectTitle: "計劃名稱",
        applicationRefNO: "計劃編號",
        projectCoordinator: "計劃統籌員姓名",
        contactPerson: "聯絡人姓名",
        contactTelNo: "聯絡電話",
        stepOption: {
            ActivitiesWithSchoolPart1: "與學校協作的活動",
            ActivitiesOpenCommunityPart1: "服務整個地區的活動",
        },
        activitiesSchoolTips: "請填寫所有核准活動的資料",
        ngoChopFile: "印鑑",
        selectContent: "選擇要填寫的內容",
        activitiesInformation: "甲. 計劃的各項活動資料",
        activitiesSchoolIa: "(I) (a) 與學校協作的活動（列明所有獲批活動）",
        activitiesStudentsNo: "活動獲批核的合資格學生人數",
        activitiesStudentsNoBefore: "活動獲批核的合資格學生",
        activitiesStudentsNoAfter: "人數",
        totalActivitiesStudentsNo: "活動獲批核的合資格學生總人次",
        activityName: "活動名稱",
        schoolName: "協作學校名稱",
        actualNo: "實際參與學生人數",
        remark: "備註",
        remarkEg: "（如註明活動日期，例：逢星期一、三及五下午4:00-5:30）",
        eligibleStudents: "合資格學生",
        nonEligiblestudents: "非合資格學生",
        secdNoTitle: "中學人數",
        priNoTitle: "小學人數",
        specNoTitle: "特殊學校人數",
        average: "平均出席率（%）",
        isSchedule: "活動是否如期舉辦",
        financialReport: "財務報告",
        flagOption: {
            0: "否",
            1: "是",
        },
        a1: "活動資助額 (HK$) (A1)",
        b1: "其他收入 (HK$) (B1)",
        c1: "機構補貼 (HK$) (C1)",
        d1: "開支 (HK$) (D1)",
        a2: "活動資助額 (HK$) (A2)",
        b2: "其他收入 (HK$) (B2)",
        c2: "機構補貼 (HK$) (C2)",
        d2: "開支 (HK$) (D2)",
        totalTitle: "總計",
        activitiesTotalNo: "活動項目總數",
        priTotalNo: "小學總人數",
        secdTotalNo: "中學總人數",
        specTotalNo: "特殊學校總人數",
        manTimesTotal: "人次（上列人數的總和）",
        a1Total: "活動資助額總計 (HK$) (A1)",
        b1Total: "其他收入總計 (HK$) (B1)",
        c1Total: "機構補貼總計 (HK$) (C1)",
        d1Total: "開支總計 (HK$) (D1)",
        a2Total: "活動資助額總計 (HK$) (A2)",
        b2Total: "其他收入總計 (HK$) (B2)",
        c2Total: "機構補貼總計 (HK$) (C2)",
        d2Total: "開支總計 (HK$) (D2)",
        activitiesSchoolIb: `(I) (b) 協作學校的參加學生資料（截至{{upToDateTc}}為止）`,
        activitiesSchoolIbi: "（i）領取綜援的學生",
        activitiesSchoolIbii: "（ii）領取學生資助計劃全額津貼的學生",
        activitiesSchoolIbiii:
            "（iii）學校使用酌情權的清貧學生（不超過25%）（只適用於與學校協作，並由校方提供）",
        activitiesSchoolIbiv: "（iv）受惠的合資格學生（i）+（ii）+（iii）共＝",
        activitiesSchoolIbv: "（v）非合資格學生（必須繳付全費）",
        activitiesSchoolIbvBefore: "（v）非合資格",
        activitiesSchoolIbvAfter: "學生（必須繳付全費）",
        activitiesSchoolIbTotal: "總人數:（iv）+（v）＝",
        schoolTypeOption: {
            primarySchool: "小學",
            secondarySchool: "中學",
            specialSchool: "特殊學校",
        },
        primarySchool: "小學",
        studentsNo: "人數",
        studentsTitleBefore: "如有下列類別",
        studentsTitleAfter: "，請填寫",
        applicableType: "如果適用",
        NCS: "非華語學生",
        SEN: "有特殊學習需要的學生",
        NAC: "新來港學童",
        secondarySchool: "中學",
        specialSchool: "特殊學校",

        activitiesCommunityIIA:
            "(II) (a) 服務整個地區的活動（列明所有獲批活動）",
        actualSituationOption: {
            "(a)": "已完成",
            "(b)": "正在進行",
            "(c)": "未開展",
            "(d)": "取消",
        },
        actualSituation: "活動是否如期舉辦",
        approvedStudentsNo: "活動獲批核的合資格學生人數",
        Od: "Od",
        Pv: "Pv",
        Cs: "Cs",
        odTips: "來自(I)項以外的官立、津貼、按位津貼學校、直接資助計劃學校及私立學校的學生",
        pvTips: "來自私立學校的學生",
        csTips: "來自(I)項所列協作學校的學生",
        schoolType: "學校類型",
        primaryOd: "Od（小學）",
        primaryPv: "Pv（小學）",
        primaryCs: "Cs（小學）",
        secondaryOd: "Od（中學）",
        secondaryPv: "Pv（中學）",
        secondaryCs: "Cs（中學）",
        specialOd: "Od（特殊學校）",
        specialPv: "Pv（特殊學校）",
        specialCs: "Cs（特殊學校）",
        averageRate: "平均出席率（%）",
        odTotal: "Od總計",
        pvTotal: "Pv總計",
        csTotal: "Cs總計",
        primaryOdTotal: "Od總計（小學）",
        primaryPvTotal: "Pv總計（小學）",
        primaryCsTotal: "Cs總計（小學）",
        secondaryOdTotal: "Od總計（中學）",
        secondaryPvTotal: "Pv總計（中學）",
        secondaryCsTotal: "Cs總計（中學）",
        specialOdTotal: "Od總計（特殊學校）",
        specialPvTotal: "Pv總計（特殊學校）",
        specialCsTotal: "Cs總計（特殊學校）",
        approvedStudentsNoTotal: "總人次（上列人數的總和）",
        approvedStudentsNoTotalNonEligible: "總人次（上列人數的總和）",
        activitiesCommunityIIB: `(II) (b) 參加地區活動的學生資料（截至{{upToDateTc}}）為止`,
        activitiesCommunityIIBvi: "(vi) 領取綜援的學生",
        activitiesCommunityIIBvii: "(vii) 領取學生資助計劃全額津貼的學生",
        activitiesCommunityIIBviii: "(viii) 受惠的合資格學生: (vi) + (vii) ＝",
        primaryHeads: "小學（人數）",
        secondaryHeads: "中學（人數）",
        specialHeads: "特殊學校（人數）",
        totalHeads: "總計（人數）",
        typeStudentsNo: "如有下列類別",
        typeStudentsNoBefore: "如有下列類別",
        typeStudentsNoAfter: "，請填寫",
        ncs: "NCS",
        sen: "SEN",
        nac: "NAC",
        totalViii: "總計（人數）：（vi）總計+（vii）總計＝",
        totalNcs: "總計（NCS）：（vi）NCS+（vii）NCS＝",
        totalSen: "總計（SEN）：（vi）SEN+（vii）SEN＝",
        totalNac: "總計（NAC）：（vi）NAC+（vii）NAC＝",
        activitiesCommunityIIBix: "（ix）非合資格學生（必須繳付全費）：",
        activitiesCommunityIIBixBefore: "(ix) 非合資格",
        activitiesCommunityIIBixAfter: "學生（必須繳付全費）：",
        activitiesCommunityIIBTotal: "總人數（viii）+（ix）＝",
        activitiesCommunityIIBx: "總人數（viii）+（ix）＝",
        totalX: "總計（人數）：（viii）總計+（ix）總計＝",
        totalXNcs: "總計（NCS）：（viii）NCS+（ix）NCS＝",
        totalXSen: "總計（SEN）：（viii）SEN+（ix）SEN＝",
        totalXNac: "總計（NAC）：（viii）NAC+（ix）NAC＝",
        financialSummaryIII: `(III) 整個計劃財務資料總結（截至{{upToDateTc}}為止）`,
        summaryE: "(E) 行政費開支",
        summaryF: "(F) 計劃統籌開支",
        summaryG: "(G) 機構補貼計劃行政費及統籌費開支",
        summaryH: "(H) 計劃總開支 = (D1) + (D2) + (E) + (F)",
        summaryI: "(I) 獲批資助總額",
        summaryJ: "(J) 所賺取利息 (如有)",
        summaryK:
            "(K) 計劃總收入 = (B1) + (B2) + (C1) + (C2) + (G) + (I) + (J)",
        summaryBalance: "結餘 = (K) – (H)",
        summaryTips:
            "<i>請按照申請表J部第5項填寫，即本報告截止日期前批核給貴機構執行此計劃的總撥款</i>",
        effectiveness: "乙.計劃成效",
        effectivenessTips:
            "整體來說，你認為已完成／正進行的活動對受惠合資格學生有何得益？",
        learningEffectiveness: "學習成效",
        effectivenessOption: {
            1: "明顯改善",
            2: "適度改善",
            3: "輕微改善",
            4: "沒有改變",
            5: "下降",
            6: "不適用",
        },
        learningMotivation: "a）學生的學習動機",
        studySkills: "b）學生的學習技巧",
        academicAchievement: "c）學生的學業成績",
        outsideExperience: "d）學生於課堂外的學習經歷",
        overallEffectivenes: "e）你對學生學習成效的整體觀感",
        development: "個人及社交發展",
        selfEsteem: "f）學生的自尊心",
        selfManagement: "g）學生的自我照顧能力",
        socialSkills: "h）學生的社交技巧",
        interpersonalSkills: "i）學生的人際技巧",
        cooperativenessSkill: "j）學生與他人合作能力",
        attitudesToward: "k）學生對求學的態度",
        outlookOnLife: "l）學生的人生觀",
        overallView: "m）你對學生個人及社交發展的整體觀感",
        communityInvolvement: "社區參與",
        participation: "n）學生參與課外及義工活動的情況",
        belongingSense: "o）學生的歸屬感",
        understanding: "p）學生對社區的了解",
        overallView2: "q）你對學生參與社區活動的整體觀感",
        comments: "丙.對已完成計劃的意見",
        difficulties:
            "在推行計劃時，你有否遇到以下問題／困難?\n（可在方格上√超過一項）：",
        difficultiesOption: {
            manpower: "沒有足夠人力推行計劃",
            eligibleStudents:
                "協作學校未能提供足夠的合資格學生（即領取綜援及學生資助計劃全額津貼的學生）參加活動",
            eligibleUnwilling: "合資格學生不願意參加計劃",
            collaborating: "協作學校未能與機構配合提供適當的支援",
            unableEmploy: "難以聘請合資格導師推行活動",
            funds: "執行教育局在處理撥款方面的要求感到困難",
            reportComplicated: "提交報告的要求感到繁複及費時",
            other: "其他",
        },
        specify: "請說明",
        specifyReason: "請說明其原因",
        otherMsg: "意見",
        suggestions:
            "如你對區本計劃有其他意見（例如：協作模式、活動類別等），請在下方說明",
        incomeExpenditure: `(截至{{upToDateTc}}) 活動收支表`,
        projectInformation: "項目基本情況",
        actualEligibleNo: "實際合資格學生參加人數",
        actualNoneligibleNo: "實際非合資格學生參加人數",
        incomeItems: "收入項目",
        grantAmount: "此項活動獲批撥款金額",
        nonEligibleFees: "非合資格學生收費",
        othersIncome: "其他收入",
        otherSpecify: "請註明",
        othersExpenditure: "其他開支",
        totalA: "總收入（A）",
        subsidyB: "機構補貼（B）",
        expenditureItems: "開支項目",
        activityGroupsTitle: "已進行活動情況",
        classroom: "課堂",
        totalGroups: "共開（組）",
        sessions: "每組（節）",
        hr: "小時",
        activity: "活動",
        activityGroups: "每組（次）",
        tutorFee: "導師開支",
        statement: "聲明",
        halfDay: "半日",
        fullDay: "全日",
        tutorsNo: "導師人數",
        hourlySalary: "時薪",
        otherStaffNo: "其他人數",
        socialWorkersNo: "社工人數",
        tutorTotal: "導師總計開支",
        socialWorkerTotal: "社工總計開支",
        othersTotal: "其他總計開支",
        material: "活動物資",
        campAdmissionFee: "營費／入場費",
        studentsMeal: "學生膳食",
        transportationFee: "活動交通費",
        volunteersNo: "義工人數",
        volunteersAllowance: "義工津貼",
        totalC: "總開支（C）",
        balance: "結餘（A+B-C）",
        fullOrHalf: "半日或是全日",
        fullOrHalfOption: {
            half: "半日",
            full: "全日",
        },
        incomeExpenditureChecked:
            "本人已審閱本表格內填報的資料，包括核實所有支出單據確認真實無誤，並確認該申請撥款的活動已在進行或已完成。",
        activitiesSchool: "(I) 與學校協作的活動",
        approvedProject: "核準計劃資料",
        activitiesTotal1: "活動項目總數（a1）",
        activitiesTotal2: "活動項目總數（a2）",
        schoolsTotal: "學校總數",
        completedTotal: "已完成總數",
        inProgressTotal: "進行中總數",
        notCommencedTotal: "未開展總數",
        cancelledTotal: "擬取消總數",
        adjustmentTotal: "需修訂總數",
        a1a2Total: "合計：（I）+（II）的核準活動項目總數＝（a1）+（a2）",
        costA: "獲批計劃行政費總額（A）",
        AdministExpenses: "計劃行政開支項目",
        transportationFees: "工作人員交通費",
        photoCopy: "影印費",
        stationery: "文儀用品",
        postage: "郵費",
        totalB: "計劃行政總開支（B）",
        costC: "機構補貼計劃行政費（如有）（C）",
        balanceD: "計劃行政費結餘（D）＝（A＋C－B）",
        costE: "獲批計劃統籌開支總額（E）",
        costF: "計劃統籌開支（F）",
        costG: "機構補貼計劃統籌費（如有）（G）",
        balanceH: "計劃統籌結餘（H）＝（E＋G－F）",
        costI: "(I) 獲批資助總額",
        costJ: "(J) 所賺取利息（如有）",
        ngoType: "非政府機構／非政府機構的部門／非政府機構的附屬機構名稱",
        ngoName: "{{ngoType}}名稱",
        ngoHeadType:
            "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人／計劃統籌員",
        ngoHeadTypeName: "{{ngoType}}負責人／計劃統籌員",
        ngoHeadName: "姓名",
        ngoHeadPost: "職位",
        ngoHead: "{{ngoType}}負責人",
        statementCost: `(截至{{upToDateTc}}) 計劃行政費及統籌開支表`,
        checkedFlag:
            "本人已審閱本表格內填報的資料，包括核實所有支出單據真實無誤。",
        Notes: "註意",
        statementCheck: "本人已閱讀、明白及同意上述條款及細則",
    },
    select: {
        ngoOption: {
            ngo: "非政府機構",
            department: "非政府機構的部門",
            subsidiaryOrganisation: "非政府機構的附屬機構",
        },
        ngoHeadOption: {
            ngoHead: "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人",
            projectCoordinator: "計劃統籌員",
        },
    },
    comma: "，",
    semicolon: "；",
    errorMsg: {
        "E-0120": "前3項中的一項是必需的",
        "E-0122": "需要兩個部分中的一個",
        "E-0123": "{{fildName}}不可重複",
        "E-0125": "此必須至少包含1項",
        "E-0126": "前三項必須填寫一項",
        "E-0127": "此項必須小於或等於{{fildName}}",
        "E-0128": "請不要選擇重複的學校類型",
    },
};
export default Form005TC;
